import React, { useEffect } from 'react';
import DashboardView from './DashboardView';
import useDashboardLogic from './DashboardLogic';
import { trackPageView } from '../../services/analyticsService';

const Dashboard = () => {
  const { projects, loading } = useDashboardLogic();
  
  useEffect(() => {
    // Track dashboard page view
    trackPageView('Dashboard');
  }, []);
  
  return (
    <DashboardView 
      projects={projects}
      loading={loading}
    />
  );
};

export default Dashboard; 